import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Radio, Row, Upload } from 'antd'
import { useDeepEffect } from '../../../../utils/hooks'
const BrandActivityStatusForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        enable: formData.enabled,
      })
    }

    return () => {
      form.resetFields()
    }
  }, [formData])


  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          enable: values.enable,
        }
        if (!_.isEmpty(formData)) {
          data.brandActivityId = formData.id
        }
        onOk(data)
        console.log
      }
    })
  }

  return (
    <Modal
      title={`Update Status`}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
      <Form.Item label="Status">
        {getFieldDecorator(`enable`, {
          rules: [
            {
              required: true,
              message: 'กรุณาเลือก'
            }
          ]
        })(
          <Radio.Group>
              <Radio value={true}>Active</Radio>
              <Radio value={false}>Inactive</Radio>
          </Radio.Group>
        )}
      </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <Button color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedBrandActivityStatusForm = Form.create({ name: 'BrandActivityStatusForm' })(
  BrandActivityStatusForm
)
export default WrappedBrandActivityStatusForm
